import { render, staticRenderFns } from "./ChartsPie.vue?vue&type=template&id=7a945f83&scoped=true&"
import script from "./ChartsPie.vue?vue&type=script&lang=js&"
export * from "./ChartsPie.vue?vue&type=script&lang=js&"
import style0 from "./ChartsPie.vue?vue&type=style&index=0&id=7a945f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a945f83",
  null
  
)

export default component.exports